document.addEventListener('DOMContentLoaded', function () {
  const forms = document.querySelectorAll('.gform_wrapper form');
  forms.forEach(form => {
    markSelects(form);
    markInputs(form);
    markTextareas(form);
  });

  const observer = new MutationObserver(() => {
    const forms = document.querySelectorAll('.gform_wrapper form');
    forms.forEach(form => {
      markSelects(form);
      markInputs(form);
      markTextareas(form);
    });

    initFaqs();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  const donateButtons = document.querySelectorAll('.is-style-donate .wp-element-button');

  donateButtons.forEach(button => {
    const burstContainer = document.createElement('div');
    burstContainer.classList.add('burst-container');

    button.appendChild(burstContainer);
  });


  document.querySelectorAll('.is-style-donate .wp-element-button').forEach(button => {
    const burstContainer = button.querySelector('.burst-container');
  
    const burst = new mojs.Burst({
      parent: burstContainer,
      radius: { 10: 30 },
      count: 15,
      duration: 1200,
      angle: { 0: 180 },
      degree: 360,
      children: {
        shape: [ 'circle', 'polygon' ],
        fill: [ '#ffffff', '#ffffff', '#ffffff' ],
        angle: { 0: 180 },
        degreeShift: 'rand(-360, 360)',
        delay: 'stagger(0, 25)',
        radius: 2,
      }
    });
  
    button.addEventListener('mouseenter', () => {
      setTimeout(() => {
        burst.replay();
      }, 300);
  
      button.classList.remove('heart-beat');
      void button.offsetWidth;
      button.classList.add('heart-beat');
    });

    setTimeout(() => {
      burst.replay();
      button.classList.remove('heart-beat');
      void button.offsetWidth;
      button.classList.add('heart-beat');
    }, 2000);
  });


});

function markSelects(context = document) {
  const selects = context.querySelectorAll('select');

  selects.forEach(select => {
    const toggleClass = () => {
      const value = select.value?.trim();
      select.classList.toggle('has-value', !!value);
    };

    toggleClass();
    select.removeEventListener('change', toggleClass);
    select.addEventListener('change', toggleClass);
  });
}

function markInputs(context = document) {
  const inputs = context.querySelectorAll('input');

  inputs.forEach(input => {
    const toggleClass = () => {
      input.classList.toggle('has-value', !!input.value?.trim());
    };

    const handleFocus = () => input.closest('.gfield')?.classList.add('has-focus');
    const handleBlur = () => input.closest('.gfield')?.classList.remove('has-focus');

    toggleClass();
    input.removeEventListener('input', toggleClass);
    input.addEventListener('input', toggleClass);
    input.addEventListener('change', toggleClass);

    input.addEventListener('focus', handleFocus);
    input.addEventListener('blur', handleBlur);
  });
}

function markTextareas(context = document) {
  const textareas = context.querySelectorAll('textarea');

  textareas.forEach(textarea => {
    const toggleClass = () => {
      textarea.classList.toggle('has-value', !!textarea.value?.trim());
    };

    const handleFocus = () => textarea.closest('.gfield')?.classList.add('has-focus');
    const handleBlur = () => textarea.closest('.gfield')?.classList.remove('has-focus');

    toggleClass();
    textarea.removeEventListener('input', toggleClass);
    textarea.addEventListener('input', toggleClass);
    textarea.addEventListener('change', toggleClass);

    textarea.addEventListener('focus', handleFocus);
    textarea.addEventListener('blur', handleBlur);
  });
}

function initFaqs() {
  document.querySelectorAll('.schema-faq-section').forEach((el) => {
    el.querySelector('.schema-faq-question').onclick = function () {
      el.classList.toggle('schema-faq-section--open');
    };
  });
}